import { ColorProps, InputTypesProps, SizeProps, VariantProps } from "./types";

export const mediaQueries = { sm: 640 };

export const navbar_width = 80;

export const defaultSizes: SizeProps[] = ["2xs", "xs", "sm", "base", "lg", "xl", "2xl"];

export const theme_colors: ColorProps[] = ["primary", "secondary"];

export const variants: VariantProps[] = ["primary", "secondary", "ghost", "outline", "text"];

export const input_types: InputTypesProps[] = ["number", "password", "text", "file"];
